import React from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import OrderIconLarge from "../icons/OrderIconLarge";
import { Link, useHistory } from 'react-router-dom';
import { useOrdersFilter } from '../../hooks/OrdersFilterContext';
export const ActiveOrders = (props) => {
    const { clearFilters, updateFilter } = useOrdersFilter();
    const history = useHistory();

    const orderData = props.orderData;
    const locale = props.locale == "en_US"
    const classChoiceTop = locale ? "font-size-20" : "font-size-28";
    const classChoiceBottom = !locale ? "font-size-20" : "font-size-28";

    const handleOrderFilterClick = () => {
        clearFilters();
        const statuses = props.isFueling
            ? ["BeingProcessed", "Shipped"]
            : props.availableStatuses
                .filter(x => x.isQuoteStatus === false && x.shown === true && x.isActiveStatus === true)
                .map(x => x.description);

        updateFilter('status', statuses);
        updateFilter('dateRange', '729');
        const query = {
            statuses: statuses.join(','),
            dateRange: 729
        };

        history.push({
            pathname: "/orders",
            search: new URLSearchParams(query).toString()
        });
    };
    return (
        <>
            {props.storeSettings.settingsList.UseDashboardActiveOrders == "1" &&
                <div className="gray-box">
                        <button
                            style={{ all: 'unset', cursor: 'pointer' }}
                        onClick={handleOrderFilterClick}
                        >
                        <div className="flex">
                            <div><OrderIconLarge /></div>
                        <div className="big-number">
                            <div className="font-size-64">
                                {orderData.totalActiveOrders}
                            </div>

                                <div className="label-wrapper">
                                    <div className={classChoiceTop}>
                                    {props.dashboardLabels.ACTIVE}
                                </div>
                                    <div className={classChoiceBottom }>
                                    {props.dashboardLabels.ORDERS}
                                </div>
                            </div>
                        </div>
                        
                        </div>
                    </button>
                </div>
            }
        </>
    );
}

ActiveOrders.propTypes = {
    orderData: PropTypes.object
};
function mapStateToProps(state) {
    return {
        selectedCustomer: state.user.selectedCustomer,
    };
}

export default connect(mapStateToProps, null)(ActiveOrders);